import React, { Component } from 'react';
import { bool } from 'prop-types';
import styled, { css } from 'styled-components';
import Text from './Text';

const FooterContainer = styled.div`
    display: block;
    ${({ isPrinting }) => !isPrinting && css`
        display: none;
    `}
    position: fixed; bottom: 0px;
    text-align: center;
    width: 18.8cm;
`;

export default class Fiiter extends Component {
    static propTypes = {
        isPrinting: bool
    }

    render () {
        const { isPrinting } = this.props;
        return (
            <FooterContainer isPrinting={isPrinting}>
                <Text text='Si tienes cualquier consulta llámenos a&nbsp;' />
                <Text text='600 400 3000' strong />
                <Text text='&nbsp;o escríbenos a&nbsp;' />
                <Text text='contacto@jumbo.cl' strong />
            </FooterContainer>
        );
    }
}
